export default __webpack_public_path__ + "static/ck-59895086542cb66f14171e55e06a3cd9.png";